/* Polsk katalog for locale-payroll-payments-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'err.pensionCorrection.inactive': 'Brak aktywnej płatności OTP do skorygowania.',
  'err.pensionCorrection.legacy': 'Tę historyczną płatność OTP trzeba skorygować po przeglądzie księgowym.',
  'err.pensionCorrection.stale': 'Płatność OTP została zmieniona. Odśwież stronę przed korektą.',
  'err.pensionCorrection.reason': 'Podaj przyczynę korekty.',
  'err.pensionCorrection.reported': 'Przed korektą OTP w zgłoszonych wynagrodzeniach trzeba przejrzeć A-melding.',
  'err.pensionCorrection.settled': 'Przed korektą OTP anuluj płatność składki pracodawcy za dany okres.',
  'err.pensionCorrection.missing': 'Nie znaleziono księgowania płatności OTP.',
  'pay.viewPensionPosting': 'Zobacz dekretację',
  'pay.pensionDetails': 'Zobacz płatność',
  'pay.correctPensionPayment': 'Skoryguj płatność OTP',
  'pay.annulPensionPayment': 'Anuluj płatność OTP',
  'pay.pensionCorrectionSaved': 'Płatność OTP została skorygowana.',
  'pay.correctionReason': 'Przyczyna korekty',
  'pay.pensionCorrectionExplanation': 'Pierwotna płatność OTP zostaje stornowana w pierwotnym, otwartym okresie. Przy korekcie rejestrowana jest nowa płatność. Lista płac i wypłata wynagrodzenia pozostają bez zmian. Zmienia to księgowanie, a nie wykonany przelew bankowy.',
  'trv.approveExpense': 'Zatwierdź wydatek',
  'pay.taxOnNonCashBenefits': 'Zaliczka na podatek od świadczeń niepieniężnych',
  'pay.netReconciliation': 'Różnica między pozycjami płacowymi a zapisaną kwotą netto',
  'pay.netAdjustmentExplanation': 'Potrącane z wypłaty gotówkowej; podatek uwzględniono powyżej.',
  'pay.viewPayslip': 'Zobacz pasek wynagrodzenia',
  'pay.resendPayslip': 'Wyślij ponownie',
  'pay.missingPensionBankAccountReminder': 'Nie dodano rachunku bankowego. Pamiętaj, aby dodać rachunek, z którego opłacono emeryturę. Możesz mimo to zarejestrować płatność.',
  'pay.missingBankAccountReminder': 'Nie dodano rachunku bankowego. Pamiętaj, aby dodać rachunek, z którego wypłacono wynagrodzenie. Możesz mimo to zarejestrować wypłatę.',
});
